import { render, staticRenderFns } from "./ResultItemValCredit.vue?vue&type=template&id=2985cd8a&scoped=true&"
import script from "./ResultItemValCredit.vue?vue&type=script&lang=js&"
export * from "./ResultItemValCredit.vue?vue&type=script&lang=js&"
import style0 from "./ResultItemValCredit.vue?vue&type=style&index=0&id=2985cd8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2985cd8a",
  null
  
)

export default component.exports